module.exports = __webpack_public_path__ + "img/about_us_5.0cb26c63.png";